/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { IntlProvider } from 'react-intl';

import { makeSelectLocale } from './selectors';
import { changeLocale } from './actions';
const store = require('store');

export class LanguageProvider extends React.PureComponent {

  componentDidMount(){

    let allowed = ['nl', 'de', 'en', 'pl'];

    let locale = (store.get('locale') || navigator.language || navigator.userLanguage || 'nl').toLowerCase();

    locale = locale.split('-').shift();

    if(allowed.indexOf(locale) === false) locale = 'nl';

    this.props.changeLocale(locale);

  }

  render(){
      let props = this.props;
      return (
      <IntlProvider
        locale={props.locale}
        key={props.locale}
        messages={props.messages[props.locale]}
        onError={ (e) => {
          let str = e.match(/(\"(.*?)\")/)[0].replace(/\"/g,'');

          if(!window.__missing_locales) window.__missing_locales = {};

          window.__missing_locales[str] = "";

          clearTimeout(window.__missing_locales_t);

          window.__missing_locales_t = setTimeout(() => {
            console.log("missing " + Object.keys(window.__missing_locales).length +" locales");
            console.dir(window.__missing_locales);
          },1000);

        }}
      >
        {React.Children.only(props.children)}
      </IntlProvider>
    );
  }
}

LanguageProvider.propTypes = {
  locale: PropTypes.string,
  messages: PropTypes.object,
  children: PropTypes.element.isRequired,
};

const mapStateToProps = createSelector(
  makeSelectLocale(),
  locale => ({
    locale,
  }),
);

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    changeLocale: (lang) => dispatch(changeLocale(lang)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LanguageProvider);
